import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";

import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';

import { ArretSlbTLR } from '../entities/arret-slb-tlr.entity'; 
import { AccesParcInfo } from '../../acces/entities/acces-parc-info.entity';

@Injectable({ providedIn: 'root' })
export class ArretSlbService {
	private path: string;

	constructor( //
		@Inject(HttpClient) private httpClient: HttpClient, //
		@Optional() @SkipSelf() previousInstance?: ArretSlbService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
	}
	
	// Methode permettant d'obtenir les donnees d'un arret, actualisees par Darwin
	public getActualizationByUid(arretUid: string): Observable<ArretSlbTLR> {
		let url = this.path + "arrets-slb/" + arretUid + "?actualize=true";
		let result = this.httpClient //
			.get<ArretSlbTLR>(url) //
		;

		return result;
	}

	// Methode permettant de recuperer les arrets lies a un acces
	public getByAcces(accesId: number): Observable<ArretSlbTLR[]> {
		let url = this.path + "acces/" + accesId + "/arrets-slb";
		let result = this.httpClient //
			.get<ArretSlbTLR[]>(url) //
		;

		return result;
	}
	
	// Methode permettant de recuperer les arrets lies a un ouvrage
	public getByOuvrage(accesId: number, ouvrageId: number, days: number): Observable<ArretSlbTLR[]> {
		let url = this.path + "ouvrages/" + ouvrageId + "/acces/" + accesId + "/arrets-slb?days=" + days;
		let result = this.httpClient //
			.get<ArretSlbTLR[]>(url) //
		;

		return result;
	}
	
	// Methode permettant de savoir si des arrêts sont associés à des accès
	public adviseIfStopsAreAssociatedToAcces(uids: string[]): Observable<{ [key: string]: AccesParcInfo  }> {
		let url = this.path + "arrets-slb/adviseIfStopsAreAssociatedToAcces";

		let result = this.httpClient //
			.post<{ [key: string]: AccesParcInfo  }>(url, uids) //
		;

		return result;
	}
}